module.exports = __webpack_public_path__ + "static/useEffect-5cd7e64da87e7f6d12ae9a2cd820b37a.gif";